import React from 'react';
import { Head, usePage } from '@inertiajs/react';
import EventForm from '../../components/EventForm/EventForm';
import type { EventFormProps } from '../../components/EventForm/types';

// Styles
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/dates/styles.css';
import '../../styles/Login-form.css';

export default function CreateEvent() {
  const { props } = usePage<EventFormProps>();

  return (
    <>
      <Head title={props.event.id ? 'Edit Event' : 'Create New Event'} />
      <EventForm
        event={props.event}
        artists={props.artists}
        event_types={props.event_types}
        dance_styles={props.dance_styles}
        event_frequencies={props.event_frequencies}
        organizers={props.organizers}
        errors={props.errors}
        areas={props.areas}
        cities={props.cities}
        timezones={props.timezones}
        users={props.users}
        event_statuses={props.event_statuses}
      />
    </>
  );
}
